import { motion } from "framer-motion";
import { HexMark } from "@/components/BrandMark";

export function SectionEyebrow({ children, light = false }) {
  return (
    <div
      className={`inline-flex items-center gap-2 ${
        light ? "overline text-white/70" : "overline"
      }`}
    >
      <HexMark
        size={10}
        strokeWidth={1.6}
        className={light ? "text-accent" : "text-accent"}
      />
      <span>{children}</span>
    </div>
  );
}

export function SectionHeader({ eyebrow, title, intro, align = "left", testId }) {
  return (
    <div
      data-testid={testId}
      className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}
    >
      {eyebrow && <SectionEyebrow>{eyebrow}</SectionEyebrow>}
      <h2 className="mt-5 font-display text-4xl sm:text-5xl tracking-tight font-medium leading-[1.05]">
        {title}
      </h2>
      {intro && (
        <p className="mt-6 text-base sm:text-lg text-muted-foreground leading-relaxed">
          {intro}
        </p>
      )}
    </div>
  );
}

export function PageHero({ eyebrow, title, intro, image, testId }) {
  return (
    <section data-testid={testId} className="pt-28 pb-20 sm:pt-36 sm:pb-28 border-b border-border bg-white">
      <div className="container-x grid lg:grid-cols-12 gap-12 items-end">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="lg:col-span-7"
        >
          <SectionEyebrow>{eyebrow}</SectionEyebrow>
          <h1 className="mt-6 display-xxl text-5xl sm:text-6xl lg:text-7xl text-primary">
            {title}
          </h1>
          {intro && (
            <p className="mt-8 text-lg sm:text-xl text-muted-foreground max-w-2xl leading-relaxed">
              {intro}
            </p>
          )}
        </motion.div>
        {image && (
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
            className="lg:col-span-5 img-zoom border border-border bg-secondary aspect-[4/3] lg:aspect-[3/4]"
          >
            <img src={image} alt="" className="w-full h-full object-cover" />
          </motion.div>
        )}
      </div>
    </section>
  );
}

export function Reveal({ children, delay = 0, y = 18 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}

export function HexIcon({ children, className = "" }) {
  return (
    <div
      className={`relative inline-flex items-center justify-center w-12 h-12 ${className}`}
    >
      <HexMark size={48} strokeWidth={1.6} className="absolute inset-0" />
      <div className="relative">{children}</div>
    </div>
  );
}
